<template>
    <div class="auction__filters">
        <el-select class="auction__select" v-model="filter.history">
            <el-option value="all" label="Все"></el-option>
            <el-option value="today" label="В продаже сегодня"></el-option>
            <el-option value="archive" label="История продаж"></el-option>
            <svg slot="prefix">
                <use xlink:href="/assets/front/img/sprite.svg#icon-compass"></use>
            </svg>
        </el-select>
        <el-select class="auction__select" v-model="filter.city">
            <el-option value="all" label="Любой город"></el-option>
            <el-option  v-for="item in cities"
                        :key="item.id"
                        :label="item.title"
                        :value="item.id"></el-option>
            <svg slot="prefix">
                <use xlink:href="/assets/front/img/sprite.svg#icon-compass"></use>
            </svg>
        </el-select>
        <el-select class="auction__select" v-model="filter.category">
            <el-option value="all" label="Любая категория"></el-option>
            <el-option v-for="item in categories"
                       :key="item.id"
                       :label="item.title"
                       :value="item.id"></el-option>
            <svg slot="prefix">
                <use xlink:href="/assets/front/img/sprite.svg#icon-layers"></use>
            </svg>
        </el-select>
        <el-select class="auction__select" v-model="filter.sort">
            <el-option value="end_at" label="Время до конца торгов"></el-option>
            <el-option value="title" label="По названию"></el-option>
            <svg slot="prefix">
                <use xlink:href="/assets/front/img/sprite.svg#icon-filter"></use>
            </svg>
        </el-select>
    </div>
</template>

<script>
    import {mapActions, mapState} from 'vuex';
    import {store} from "../../../store/lot";

    export default {
        name: "LotFilter",
        store,
        data: () => ({
        }),
        computed: {
            ...mapState([
                'cities',
                'categories',
                'filter'
            ]),
        },
        watch: {
            filter: {
                handler: function(val) {
                    this.getLots();
                },
                deep: true
            }
        },
        methods: {
            ...mapActions([
                'citiesList',
                'categoriesList',
                'getLots'
            ]),
        },
        mounted() {
            this.citiesList();
            this.categoriesList();
        }
    }
</script>
